import React from 'react';
import PropTypes from 'prop-types';
import {
  WelcomeMat,
  WelcomeMatTile,
  Button,
} from '@salesforce/design-system-react';

const WelcomeMatModal = (props) => {
  const { isOpen, toggleWelcomeMat } = props;

  return (
    <WelcomeMat
      style={{ minWidth: '70% !important' }}
      id="welcome-mat-splash-hero"
      labels={{
        title: 'The Hero6 App is here!',
        description:
          'Welcome to the Hero6 App, the self-service version of the Hero Workshop offering from Q Branch. This app will guide you and your account team through the Hero methodology helping you align on a visionary story. If you are new to the Hero process, we encourage you to check out the enablement resources available on the landing page as well as the Hero collection on Solution Central.',
      }}
      isOpen={isOpen}
      onRequestClose={toggleWelcomeMat}
      variant="info-only"
      onRenderInfoActions={() => (
        <Button
          type="button"
          variant="brand"
          title="Get Started"
          label="Get Started"
          id="welcome-mat-button"
          onClick={toggleWelcomeMat}
        />
      )}
    >
      <WelcomeMatTile
        title="Step 1: Determine Business Challenge"
        description="Here we dissect the core challenges of your customer and combine it into one statement."
        icon={
          <img
            src="/Images/Step1.png"
            alt="Determine Business Challenge"
            style={{ width: '3rem', height: '2.5rem' }}
          />
        }
        id="welcome-mat-tile-1"
      />

      <WelcomeMatTile
        title="Step 2: Define Personas"
        description="Determine which personas are most critical to the success of your Business Challenge."
        icon={
          <img
            src="/Images/Step2.png"
            alt="Defin Personas"
            style={{ width: '3rem', height: '2.5rem' }}
          />
        }
        id="welcome-mat-tile-2"
      />

      <WelcomeMatTile
        title="Step 3: Map The Ends"
        description="Start mapping out your story by brainstorming the beginning and the end."
        icon={
          <img
            src="/Images/Step3.png"
            alt="Map the Ends"
            style={{ width: '3rem', height: '2.5rem' }}
          />
        }
        id="welcome-mat-tile-3"
      />

      <WelcomeMatTile
        title="Step 4: Map The Middle"
        description="Now it’s time to fill in the middle milestones and flesh out your Hero’s journey."
        icon={
          <img
            src="/Images/Step4.png"
            alt="Map the Middle"
            style={{ width: '3rem', height: '2.5rem' }}
          />
        }
        id="welcome-mat-tile-4"
      />

      <WelcomeMatTile
        title="Step 5: Connect The Milestones"
        description="Not all events can be milestones! Next, add connecting events to complete the story."
        icon={
          <img
            src="/Images/Step5.png"
            alt="Connect the Milestones"
            style={{ width: '3rem', height: '3rem' }}
          />
        }
        id="welcome-mat-tile-5"
      />

      <WelcomeMatTile
        title="Step 6: Overlay Salesforce Products"
        description="Finally, weave in all Salesforce products that will power your future vision."
        icon={
          <img
            src="/Images/Step6.png"
            alt="Overlay Salesforce Products"
            style={{ width: '3rem', height: '3rem' }}
          />
        }
        id="welcome-mat-tile-6"
      />
    </WelcomeMat>
  );
};

WelcomeMatModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleWelcomeMat: PropTypes.func.isRequired,
};

export default WelcomeMatModal;
